/**
 * @brisa/ui · Button
 *
 * 3 variantes (primary, secondary, ghost) × 3 sizes (sm, md, lg).
 * Tokens Brisa aplicados via classes .brisa-btn--*. Zero hardcoded colors.
 */
import * as React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

function cx(...parts: Array<string | false | undefined | null>): string {
  return parts.filter(Boolean).join(' ');
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    type = 'button',
    disabled,
    className,
    children,
    ...rest
  },
  ref,
) {
  const classes = cx(
    'brisa-btn',
    `brisa-btn--${variant}`,
    `brisa-btn--${size}`,
    variant === 'primary' && 'brisa-btn--roxo-noite',
    variant === 'secondary' && 'brisa-btn--lavanda',
    variant === 'ghost' && 'brisa-btn--verde-fumaca',
    fullWidth && 'brisa-btn--fullWidth',
    className,
  );

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      className={classes}
      {...rest}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';
